import { useTranslation } from 'react-i18next'
import { CardContent, CardDashboard, Flex, Typography } from '@percent/lemonade'
import { useLocale } from '@percent/cause-dashboard/common/hooks/useLocale/useLocale'
import { formatDate } from '@percent/cause-dashboard/common/utility/date'
import { NominationsDetailsProps } from './NominationsDetails.types'
import styles from './NominationsDetails.module.scss'

export function NominationsDetails({ nominations, programName }: Readonly<NominationsDetailsProps>) {
  const { t } = useTranslation()
  const { locale } = useLocale()

  return (
    <Flex direction="column" data-testid="nominations-details-card">
      <CardDashboard title={t('grants.grantDetails.nominationsDetails.title')}>
        <Typography variant="default">
          {t('grants.grantDetails.nominationsDetails.description', { programName })}
        </Typography>
        {nominations.map(({ id, nominator, group, date }, index) => {
          const nominationNumber = index + 1
          return (
            <Flex key={id} direction="column" className={styles.nominationRow}>
              <Typography variant="large-bold" style={{ marginBottom: 12 }}>
                {t('grants.grantDetails.nominationsDetails.nomination.index', { index: nominationNumber })}
              </Typography>
              {nominator?.name && (
                <CardContent
                  title={t('grants.grantDetails.nominationsDetails.nomination.nominator.name')}
                  testId={`nominator-name-${nominationNumber}`}
                >
                  {nominator.name}
                </CardContent>
              )}
              {nominator?.email && (
                <CardContent
                  title={t('grants.grantDetails.nominationsDetails.nomination.nominator.email')}
                  testId={`nominator-email-${nominationNumber}`}
                >
                  {nominator.email}
                </CardContent>
              )}
              {group && (
                <CardContent
                  title={t('grants.grantDetails.nominationsDetails.nomination.group')}
                  testId={`nomination-group-${nominationNumber}`}
                >
                  {group}
                </CardContent>
              )}
              <CardContent
                title={t('grants.grantDetails.nominationsDetails.nomination.date')}
                testId={`nomination-date-${nominationNumber}`}
              >
                {formatDate(date, locale)}
              </CardContent>
            </Flex>
          )
        })}
      </CardDashboard>
    </Flex>
  )
}
